import React from "react";
import { useTranslation } from "react-i18next";
import { FEATURES } from "../landingData";

const LandingFeatures = () => {
  const { t } = useTranslation("common");

  return (
    <section className="features" id="features">
      <div className="section-header">
        <h2>{t("Everything You Need")}</h2>
        <p>
          {t(
            "From API generation to full AWS-powered integration — one platform, endless possibilities"
          )}
        </p>
      </div>
      <div className="features-grid">
        {FEATURES.map(({ color, icon, titleKey, descriptionKey }) => (
          <div key={titleKey} className="feature-card" data-color={color}>
            <div className="feat-icon">{icon}</div>
            <h3>{t(titleKey)}</h3>
            <p>{t(descriptionKey)}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default LandingFeatures;
